import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Dialog, analyticsHelpers, urlHelpers } from 'day8-ui';
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";

const { GA4_TRIGGERS } = analyticsHelpers;

const BookCall = ({
  calendlyLink,
  className
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const calendlyUrl = useMemo(() => urlHelpers.appendUTMQueryParams(calendlyLink), [calendlyLink]);

  return (
    <>
      <Card
        cardType='BORDERED'
        className={`dui-text-center ${className}`}
      >
        <h3 className='dui-text-2xl'>More questions?</h3>
        <p className='dui-my-4'>Chat to our friendly concierge team today to pick your perfect package.</p>
        <Button
          className={`${GA4_TRIGGERS.BOOK_CALL_CLASS} dui-mx-auto dui-w-full`}
          buttonType='PRIMARY'
          onClick={() => setIsModalOpen(true)}
        >
          Book a call
        </Button>
      </Card>
      <Dialog
        open={isModalOpen}
        scrollable
        onOpenChange={setIsModalOpen}
        title={(
          <div className='dui-flex dui-items-center dui-justify-between dui-mb-4'>
            <h3 className='dui-text-2xl'>Book a call</h3>
            <Button buttonType='LINK' onClick={() => setIsModalOpen(false)}><RxCross1 /></Button>
          </div>
        )}
      >
        <iframe
          title='Book a call with concierge'
          src={calendlyUrl}
          className='dui-w-full dui-min-h-[700px] dui-border-0'
        />
        <p className='dui-mt-4 dui-text-sm'>
          If the booking form does not load, you can{' '}
          <a className='dui-underline dui-font-semibold' href={calendlyUrl} target="_blank" rel="noopener noreferrer">
            open it in a new tab
          </a>.
        </p>
      </Dialog>
    </>
  );
};

BookCall.propTypes = {
  calendlyLink: PropTypes.string.isRequired,
  className: PropTypes.string
};
export default BookCall;
